// 설레임런 S3/CDN 에셋 경로. 참고: (doosanbears)/_constants/cdn.ts
export const SEOLEIMRUN_CDN = 'https://cdn.kottonseed.io/assets/seoleimrun';
export const SEOLEIMRUN_CDN_LUCKYDRAW = `${SEOLEIMRUN_CDN}/luckydraw`;
export const SEOLEIMRUN_CDN_RECEIPT = `${SEOLEIMRUN_CDN}/receipt`;
